import React from "react";
import { View, Text, Button } from "ui";
import { styled } from "styles";

export default class TermsOfService extends React.Component {
  public render = () => {
    return (
      <View flexDirection="column" alignItems="flex-start">
        <Text mb={2} alignSelf="center" fontWeight="bold" fontSize={5}>
          Termeni si Conditii
        </Text>
        <View pl={4} pr={4} mt={4} flexDirection="column">
          <Subtitle fontSize={4} text-decoration="underline">
            1. Termeni generali
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Prezentele „Termeni si Conditii” stabilesc regulile de prestare a
            serviciilor pe cale electronica de catre societatea MOTORSPORT
            ADVERTISING S.R.L., prin intermediul aplicatiei “AutoMemo”.
            Folosirea serviciilor aplicatiei “AutoMemo” este echivalenta cu
            acceptarea prezentelor „Termeni si Conditii”.
          </Text>

          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            2. Acceptarea Termenilor si Conditiilor
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Folosirea aplicatiei “AutoMemo”, inclusiv vizitarea website-ului
            acesteia, inregistrarea, folosirea serviciilor oferite de MOTORSPORT
            ADVERTISING S.R.L. si/sau de catre partenerii sai prin intermediul
            aplicatiei “AutoMemo”, implica acceptarea in totalitate si
            neconditionata a „Termenilor si Conditiilor” expuse mai jos.
          </Text>
          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            3. Prestarea Serviciilor prin intermediul aplicatiei “AutoMemo”
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Serviciile sunt prestate de societatea MOTORSPORT ADVERTISING
            S.R.L., denumita „Prestatorul de Servicii". „AutoMemo” este marca
            sub care functioneaza compania MOTORSPORT ADVERTISING S.R.L.
          </Text>
          <Text mt={2} fontSize={3}>
            Datele de identificare ale MOTORSPORT ADVERTISING S.R.L. sunt
            urmatoarele:
          </Text>
          <Text mt={2} fontSize={3}>
            • Denumire: MOTORSPORT ADVERTISING S.R.L
          </Text>
          <Text mt={2} fontSize={3}>
            • Sediu: sediu social Str. Mihai Eminescu nr. 105-107, etaj 4, ap.
            18, sector 2, Bucuresti
          </Text>
          <Text mt={2} fontSize={3}>
            • Reg. Com.: inregistrata la Registrul Comertului cu nr.
            J40/13554/2013
          </Text>
          <Text mt={2} fontSize={3}>
            • CUI: 35621370
          </Text>
          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            4. Definitii
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Termenii folositi in cadrul prezentelor „Termene si Conditii” au
            urmatoarea semnificatie:
          </Text>
          <Text mt={2} fontSize={3}>
            • denumirea utilizatorului (login) - adresa de e-mail introdusa de
            catre Utilizator, cu confirmare pe adresa de e-mail data de
            Utilizator; Utilizatorul, declara ca adresa postei electronice
            furnizata nu incalca drepturile unei terte persoane, iar toate
            eventualele litigii pe aceasta baza vor fi solutionate fara
            participarea MOTORSPORT ADVERTISING S.R.L.
          </Text>
          <Text mt={2} fontSize={3}>
            • parola - un sir de caractere pentru identificarea Utilizatorului,
            stabilit de Utilizator, in scopul obtinerii accesului autorizat la
            serviciile „AutoMemo”
          </Text>
          <Text mt={2} fontSize={3}>
            • logarea - identificarea de catre aplicatia “AutoMemo” a
            Utilizatorului respectiv care se logheaza, cu conditia scrierii de
            catre Utilizator a denumirii utilizatorului (login-ul) si a parole
          </Text>
          <Text mt={2} fontSize={3}>
            • Aplicatia “AutoMemo” - programul de calculator (software) creat si
            detinut de catre MOTORSPORT ADVERTISING S.R.L., conceput pentru a fi
            rulat pe un echipament informatic, inclusiv mobil, program care se
            gaseste pe pagina de internet: www.automemo.ro si care este
            descarcabil si de pe platformele de distributie de tipul Apple Store
            si Google Play. Acest program reprezinta culegerea de documente
            statice si dinamice, continand folderele grafice, script-urile si
            alte elemente unite prin relatii reciproce, destinata pentru
            functionarea aplicatiei
          </Text>
          <Text mt={2} fontSize={3}>
            • prestarea serviciilor pe cale electronica - efectuarea serviciilor
            care au loc prin trimiterea si preluarea datelor cu ajutorul
            sistemelor teleinformatice, la cererea individuala a Utilizatorului,
            fara prezenta in acelasi timp a partilor. Utilizatorul - persoana
            fizica ce detine capacitatea deplina pentru efectuarea activitatilor
            juridice sau intreprinzatorul - care foloseste pagina de internet
            este deplin responsabil de corectitudinea datelor introduse
          </Text>
          <Text mt={2} fontSize={3}>
            • contractantul - persoana fizica, persoana juridica sau unitatea de
            organizare care nu detine personalitate juridica, care utilizeaza
            aplicatia si achizitioneaza unul dintre pachetele disponibile
            (inclusiv cel de utilizare gratuita)
          </Text>
          <Text mt={2} fontSize={3}>
            • utilizatorul - persoana fizica care in nume propriu sau al unei
            persoane juridice, utilizeaza aplicatia “AutoMemo”
          </Text>
          <Text mt={2} fontSize={3}>
            • abonament - contractul cu perioda diferita (lunar, anual etc.) in
            baza caruia Contractantul se obliga sa furnizeze serviciile
            disponibile in aplicatia “AutoMemo”, cu conditia ca Utilizatorul sa
            fi achitat eventuala taxa de utilizare (exceptie, utilizarea
            variantei gratuite)
          </Text>
          <Text mt={2} fontSize={3}>
            • Memo - Memo poate fi un numar de masina, un numar de sasiu sau
            orice altceva creat automat si pus la dispozitie de Contractor
            si/sau customizat de Utilizator
          </Text>
          <Text mt={2} fontSize={3}>
            • Alerta - Alerta este elementul ce poate fi configurat in calendar,
            care expira, si care este asociat unui memo
          </Text>
          <Text mt={2} fontSize={3}>
            • cookies - folderele text pastrate de browserul utilizatorului pe
            hardul calculatorului si/sau telefonului, care pot fi utilizate de
            operatorii paginii de internet pentru recunoasterea utilizatorilor
            si pentru a adapta la acestia continutul afisat
          </Text>
          <Text mt={2} fontSize={3}>
            • sistemul informatic - dispozitivele informatice si de programare
            care colaboreaza intre ele, asigurand procesarea si pastrarea,
            precum si trimiterea si preluarea datelor prin reteaua de
            telecomunicatii, cu ajutorul corespunzator pentru tipul respectiv al
            retelei dispozitivului final
          </Text>
          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            5. Serviciile si Conditiile pentru servicii
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Serviciile prestate
          </Text>
          <Text mt={2} fontSize={3}>
            In cadrul aplicatiei “AutoMemo”, MOTORSPORT ADVERTISING S.R.L.
            asigura disponibiitatea si functionarea unor servicii de tip
            reminder (alerte cu notificare), pentru orice fel de categorii
            (memo)
          </Text>
          <Text mt={2} fontSize={3}>
            Utilizarea paginii web si/sau aplicatiei si protejarea informatiilor
            transmise:
          </Text>
          <Text mt={2} fontSize={3}>
            • Aplicatia “AutoMemo” poate fi folosita doar de persoanele care
            detin capacitatea deplina de a desfasura actiuni juridice
          </Text>
          <Text mt={2} fontSize={3}>
            • Folosirea aplicatiei “AutoMemo” este posibila daca in browserul de
            internet al Utilizatorului este activat serviciul java script si
            folderele cookies
          </Text>
          <Text mt={2} fontSize={3}>
            • Aplicatia “AutoMemo” este protejata cu ajutorul conectarii cifrate
            folosind protocolul https. MOTORSPORT ADVERTISING S.R.L. depune
            toate eforturile, pentru a asigura securitatea datelor trimise.
            Accesul la cont este protejat de login si parola
          </Text>
          <Text mt={2} fontSize={3}>
            • Parola trebuie pastrata intr-un loc sigur sau memorata. MOTORSPORT
            ADVERTISING S.R.L. nu isi asuma raspunderea pentru eventualele daune
            provocate de punerea la dispozitie de catre Utilizator a parolei si
            a numelui de acces persoanelor neautorizate
          </Text>
          <Text mt={2} fontSize={3}>
            • Utilizatorul are posibilitatea de a incheia, in sensul incetarii,
            in orice moment utilizarea serviciilor prestate pe cale electronica
          </Text>
          <Text mt={2} fontSize={3}>
            • Utilizatorul are posibilitatea in orice moment de a detecta si
            corecta erorile sale aparute la introducerea datelor prin
            modificarea datelor in sectiunea de administrare a contului personal
          </Text>
          <Text mt={2} fontSize={3}>
            • Daca informatiile afisate nu sunt corecte, Utilizatorul trebuie sa
            contacteze MOTORSPORT ADVERTISING S.R.L. prin orice mijloc pentru a
            solicita corectiile necesare. Mentionam ca aceste corectii se vor
            efectua doar cu prezentarea de copii ale actelor doveditoare
          </Text>
          <Text mt={2} fontSize={3}>
            • Utilizatorul este singurul responsabil pentru corectitudinea,
            realitatea si validitatea datelor si informatiilor furnizate, avand
            la cunostinta prevederile Codului Penal cu privire la falsul in
            declaratii. Utilizatorul este pe deplin raspunzator de toate daunele
            generate prin aceasta actiune MOTORSPORT ADVERTISING S.R.L.
          </Text>
          <Text mt={2} fontSize={3}>
            • MOTORSPORT ADVERTISING S.R.L. poate cesiona si/sau subcontracta o
            terta parte pentru servicii ce tin de onorarea comenzilor fara a fi
            necesar acordul Utilizatorului
          </Text>

          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            6. Protectia datelor cu caracter personal
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Administratorul datelor personale ale persoanelor asigurate este
            MOTORSPORT ADVERTISING S.R.L.. Datele personale sunt procesate
            pastrand mijloacele de siguranta solicitate de legea romana si
            respectand prevederile legii in vigoare din acest domeniu.
            MOTORSPORT ADVERTISING S.R.L. asigura Utilizatorilor posibilitatea
            schimbarii, modificarii datelor personale ale acestora precum si
            ridicarea obiectiilor cu privirea la prelucrarea datelor personale
            prin intermediul paginii de internet, cu ajutorul formularului aflat
            pe paginile www.automemo.ro.
          </Text>
          <Text mt={2} fontSize={3}>
            Administratorul datelor personale ale persoanelor asigurate este
            MOTORSPORT ADVERTISING S.R.L.. Datele personale sunt procesate
            pastrand mijloacele de siguranta solicitate de legea romana si
            respectand prevederile legii in vigoare din acest domeniu.
            MOTORSPORT ADVERTISING S.R.L. asigura Utilizatorilor posibilitatea
            schimbarii, modificarii datelor personale ale acestora precum si
            ridicarea obiectiilor cu privirea la prelucrarea datelor personale
            prin intermediul paginii de internet, cu ajutorul formularului aflat
            pe paginile www.automemo.ro.
          </Text>
          <Text mt={2} fontSize={3}>
            Conform cerintelor Legii nr. 677/2001 pentru protectia persoanelor
            cu privire la prelucrarea datelor cu caracter personal si libera
            circulatie a acestor date, modificata si completata si ale Legii nr.
            506/2004, MOTORSPORT ADVERTISING S.R.L. are obligatia de a
            administra în conditii de siguranta si numai pentru scopurile
            specificate, datele personale pe care Utilizatorul le furnizeaza
            despre el, despre un membru al familiei ori o alta persoana.
          </Text>
          <Text mt={2} fontSize={3}>
            Scopul colectarii datelor este de oferire de servicii de inalta
            calitate si in scopul facturarii corecte a abonamentelor
            achizitionate. Datele vor fi folosite si pentru activitati de
            marketing referitoare la produsele MOTORSPORT ADVERTISING S.R.L.,
            precum si a serviciilor oferite de partenerii sai.
          </Text>
          <Text mt={2} fontSize={3}>
            Utilizatorul este obligat sa furnizeze datele, acestea fiind
            necesare: pentru identificarea Utilizatorului in vederea stabilirii
            relatiei dintre acesta si Contractant.
          </Text>
          <Text mt={2} fontSize={3}>
            Informatiile înregistrate sunt destinate utilizarii de catre
            MOTORSPORT ADVERTISING S.R.L. si sunt comunicate numai urmatorilor
            destinatari: agentilor economici (furnizorilor de produse/servicii)
            si partenerilor ce au un contract semnat cu MOTORSPORT ADVERTISING
            S.R.L.
          </Text>
          <Text mt={2} fontSize={3}>
            Conform Legii nr. 677/2001, Utilizatorul beneficiaza de dreptul de
            acces, de interventie asupra datelor, dreptul de a nu fi supus unei
            decizii individuale si dreptul de a se adresa justitiei. Totodata,
            Utilizatorul are dreptul sa se opuna prelucrarii datelor personale
            care il privesc si sa solicite stergerea datelor. Pentru exercitarea
            acestor drepturi, Utilizatorul se poate adresa cu o cerere scrisa,
            datata si semnata la support@automemo.ro. De asemenea, Utilizatorul
            se poate adresa justitiei. Datele Utilizatorului nu vor fi
            transferate in alte state.
          </Text>
          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            7. Securitatea datelor
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Prin navigarea in aplicatia “AutoMemo”, MOTORSPORT ADVERTISING
            S.R.L. poate inregistra numai informatii sau date personale oferite
            in mod voluntar.
          </Text>
          <Text mt={2} fontSize={3}>
            Prin "date personale" se denumesc datele unice individuale,
            referitoare la nume, adresa, Cod Numeric Personal, CUI, numar de
            inregistrare la Registrul Comertului sau numar de telefon. Periodic,
            este posibil sa solicitam prin aplicatia “AutoMemo” informatii
            personale pentru a putea trimite materialele solicitate, a raspunde
            la intrebari sau pentru a putea oferi un produs/serviciu de
            calitate.
          </Text>
          <Text mt={2} fontSize={3}>
            Prin transmiterea de informatii sau materiale prin intermediul
            aplicatiei “AutoMemo”, Utilizatorul ofera MOTORSPORT ADVERTISING
            S.R.L. acces nerestrictionat si irevocabil la acestea, dreptul de a
            utiliza, reproduce, afisa, modifica, transmite si distribui aceste
            materiale sau informatii. Utilizatorul este, de asemenea, de acord
            ca MOTORSPORT ADVERTISING S.R.L. sa poata utiliza liber, in interes
            propriu, aceste idei, concepte, know-how-uri sau tehnici pe care
            Utilizatorul le-a trimis prin intermediul aplicatiei “AutoMemo”.
            MOTORSPORT ADVERTISING S.R.L. nu va constitui subiect de obligatii
            referitoare la confidentialitatea informatiilor trimise, daca
            legislatia in vigoare nu prevede alte specificari in acest sens.
          </Text>
          <Text mt={2} fontSize={3}>
            Conform conditiilor legale privind privind protectia datelor cu
            caracter personal, MOTORSPORT ADVERTISING S.R.L. nu va dezvalui fara
            autorizare nici o informatie referitoare la clientii nostri. Pe baza
            consimtamantului expres si neechivoc si numai in limitele
            legislatiei in vigoare, in scopul de a raspunde solicitarilor
            Utilizatorului, prin oferirea de noi produse/servicii, este posibil
            ca MOTORSPORT ADVERTISING S.R.L. sa ofere astfel de informatii catre
            terti (ex: furnizori de servicii de marketing, alti furnizori de
            servicii; agentii de stat, guvernamentale sau asociatii din domeniul
            transporturilor, atunci cand legislatia specifica prevede acest
            lucru; alte companii cu care MOTORSPORT ADVERTISING S.R.L. poate
            dezvolta programe comune de ofertare pe piata a produselor si
            serviciilor)
          </Text>
          <Text mt={2} fontSize={3}>
            MOTORSPORT ADVERTISING S.R.L. a aplicat masuri administrative,
            fizice si tehnice pentru protejarea informatiilor stocate pe acest
            site, dar nu accepta nici o responsabilitate sau raspundere privind
            securitatea datelor.
          </Text>
          <Text mt={2} fontSize={3}>
            Pentru protejarea informatiilor personale, MOTORSPORT ADVERTISING
            S.R.L. utilizeaza tehnologii de encriptare pentru anumite tipuri de
            transmisii coordonate prin acest site. Chiar daca ofera aceste
            tehnologii alaturi de alte masuri de protectie a informatiilor
            confidentiale si asigura securitatea corespunzatoare, MOTORSPORT
            ADVERTISING S.R.L. nu garanteaza ca informatiile transmise prin
            Internet sunt securizate sau ca aceste transmisii nu vor fi
            intarziate, intrerupte, interceptate sau nu vor prezenta erori, din
            motive care nu tin de MOTORSPORT ADVERTISING S.R.L..
          </Text>
          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            8. Reclamatii
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Reclamatiile referitoare la functionarea aplicatiei “AutoMemo” pot
            fi transmise folosind formularul aflat pe pagina de internet
            www.automemo.ro, accesibil la pagina de "Contact" sau de asemenea in
            scris la adresa MOTORSPORT ADVERTISING S.R.L., Str. Mihai Eminescu
            nr. 105-107, etaj 4, ap. 18, sector 2, Bucuresti.
          </Text>
          <Text mt={2} fontSize={3}>
            Reclamatia depusa corespunzator trebuie sa contina cel putin
            urmatoarele date: informatii privind Utilizatorul, prenumele si
            numele acestuia, e-mail-lul, adresa de corespondenta precum si
            descrierea problemei, la care se refera reclamatia.
          </Text>
          <Text mt={2} fontSize={3}>
            Privind rezultatul analizei reclamatiei, MOTORSPORT ADVERTISING
            S.R.L. instiinteaza neintarziat depunatorul reclamatiei prin
            intermediul postei electronice pe adresa de e-mail oferita de
            Utilizator. Reclamatiile vor fi analizate in termen de 30 de zile de
            la data primirii acestora de catre MOTORSPORT ADVERTISING S.R.L..
          </Text>
          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            9. Drepturi de autor
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Intregul continut al aplicatiei “AutoMemo” este protejat prin Legea
            drepturilor de autor, toate drepturile fiind proprietatea MOTORSPORT
            ADVERTISING S.R.L. sau a partenerilor/afiliatilor acestuia,
            exceptand cazul in care sunt recunoscute ca apartinand altor parti
            implicate.
          </Text>
          <Text mt={2} fontSize={3}>
            Folosirea aplicatiei “AutoMemo”, a informatiilor si/sau o parte a
            acestora de catre terte persoane necesita acordul in prealabil
            exprimat in scris al MOTORSPORT ADVERTISING S.R.L. sau a
            partenerilor/afiliatilor acestuia, dupa caz. Este interzisa
            copierea, modificarea, afisarea, distribuirea, transmiterea,
            publicarea, comercializarea, licentierea, crearea unor materiale
            derivate sau utilizarea continutului aplicatiei “AutoMemo” in orice
            scop fara confirmarea scrisa anticipata din partea MOTORSPORT
            ADVERTISING S.R.L. si/ sau a partenerilor sai.
          </Text>
          <Text mt={2} fontSize={3}>
            MOTORSPORT ADVERTISING S.R.L. isi rezerva dreptul de a edita
            continutul si/sau structura aplicatiei “AutoMemo”, in tot sau in
            parte, in orice moment si fara o informare prealabila a
            Utilizatorilor.
          </Text>
          <Text mt={2} fontSize={3}>
            Marcile, logo-urile sau elementele grafice continute in aplicatia
            “AutoMemo” sunt marci inregistrate ale MOTORSPORT ADVERTISING S.R.L.
            sau ale partenerilor/afiliatilor sai. Alte nume de companii, produse
            sau servicii care sunt continute in aplicatia “AutoMemo” pot fi
            marci inregistrate ale respectivilor proprietari. Utilizatorii nu au
            nici un drept sau licenta de utilizare a acestor marci inregistrate.
          </Text>
          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            10. Responsabilitate
          </Subtitle>
          <Text mt={2} fontSize={3}>
            MOTORSPORT ADVERTISING S.R.L. nu raspunde pentru nici o paguba
            (directa sau indirecta) adusa Utilizatorului sau oricarei alte
            parti, referitoare la utilizarea aplicatiei “AutoMemo” si a
            informatiilor pe care aceasta le cuprinde - de catre Utilizator sau
            alta persoana - sau orice alte pagube sau vatamari cauzate de erori,
            omisiuni, defectiuni, intarzieri sau intreruperi in operare sau
            transmitere, caderi de linie, virusi sau orice alti factori
            similari.
          </Text>
          <Text mt={2} fontSize={3}>
            Chiar daca a luat toate masurile pentru ca informatia prezentata in
            aplicatia “AutoMemo” sa fie exacta si corecta, MOTORSPORT
            ADVERTISING S.R.L. nu poate fi raspunzatoare de inexactitati care
            pot aparea in aplicatia “AutoMemo”. Utilizatorii sunt responsabili
            pentru evaluarea exactitatii, completitudinii si utilitatii
            informatiilor disponibile in aplicatia “AutoMemo”. Totodata, pentru
            utilizarea serviciilor disponibile in aplicatia “AutoMemo”
            Utilizatorul este obligat sa furnizeze date adevarate, exacte si
            complete si sa reinnoiasca atunci cand situatia o cere, datele de
            inregistrare pentru a fi adevarate, exacte si complete. In cazul
            furnizarii de informatii care nu sunt conforme cu realitatea,
            inexacte sau incomplete, MOTORSPORT ADVERTISING S.R.L. isi rezerva
            dreptul de a refuza toate incercarile curente sau viitoare de
            folosire a serviciilor aplicatiei “AutoMemo” de catre respectivul
            Utilizator.
          </Text>
          <Text mt={2} fontSize={3}>
            Orice legaturi catre alte site-uri sunt oferite numai in scopul unei
            accesibilitati sporite a informatiilor, iar MOTORSPORT ADVERTISING
            S.R.L. nu isi asuma nici o responsabilitate sau raspundere pentru
            continutul acestor site-uri, pentru produsele sau serviciile
            promovate sau comercializate prin aceste site-uri.
          </Text>
          <Text mt={2} fontSize={3}>
            Utilizatorul nu este culpabil de interventia unor terti in baza de
            date si expunerea de informatii eronate.
          </Text>

          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            11. Legea aplicabila
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Raporturile dintre MOTORSPORT ADVERTISING S.R.L. si Utilizatori sunt
            guvernate de legislatia romana.
          </Text>
          <Subtitle mt={3} fontSize={4} text-decoration="underline">
            12. Dispozitii finale
          </Subtitle>
          <Text mt={2} fontSize={3}>
            Toate comenzile efectuate de aplicatia “AutoMemo” se supun
            prevederilor prezentului document.
          </Text>
          <Text mt={2} fontSize={3}>
            Limba intrebuintata in relatiile dintre Utilizator si Contractor
            este limba disponbila si aleasa de catre Utilizator.
          </Text>
          <Text mt={2} fontSize={3}>
            MOTORSPORT ADVERTISING S.R.L. are dreptul la modificarea unilaterala
            a prevederilor din prezentul document.
          </Text>
          <Text mt={2} fontSize={3}>
            Modificarile intra in vigoare din momentul punerii la dispozitie a
            textului modificat al Termenilor si Conditiilor pe pagina de
            internet. Folosirea de catre Utilizatori a aplicatiei si a paginii
            de internet dupa introducerea acestor schimbari este echivalenta cu
            exprimarea acceptului de catre acestia.
          </Text>
          <Text mt={2} fontSize={3}>
            Prezenta versiune este valabila incepand cu data de 10.04.2014.
          </Text>
        </View>
      </View>
    );
  }
}

const Title = styled(View)`
  box-shadow: inset 0px 3px 3px grey;
  border-radius: 10px;
`;

const Subtitle = styled(Text)`
  text-decoration: underline;
`;



// WEBPACK FOOTER //
// ./src/pages/TermsOfService.tsx